import { CONFIRMATION_MODAL_ACTION } from './constants';

export function createConfirmAction(confirmation: boolean) {
  return {
    type: CONFIRMATION_MODAL_ACTION,
    confirmation
  };
}
